import { FormattedMessage, useIntl } from "react-intl"
import { NavLink } from "react-router-dom"
import { Version } from "./CommonControls"


export const Footer = () => {
    const intl = useIntl();
    return (
        <footer>
            <div className="container">
                <div className="d-flex flex-md-row flex-column p-5">
                    <div className="contact-details flex-fill pr-2">

                        <p> SER-tuottajayhteisö ry SERTY<br/>
                        Pasilankatu 2<br/>
                        00240 Helsinki</p>
                        <p>Yhdistysrekisterinumero: 180.805</p>
                        <p>Y-tunnus: 1611784-4</p>
                    </div>

                    <div className="content flex-fill pr-2">
                        <nav className="links d-flex flex-column flex-fill mb-4" aria-label={ intl.formatMessage({ id: 'links' })}>
                            <NavLink className="mr-3" to="/home/privacystatement">
                                <FormattedMessage id="info.privacystatement" />
                                <i aria-hidden="true" role="presentation" className="fa fa-arrow-circle-right ms-2"></i>
                            </NavLink>
                        </nav>
                        <p className="version"><FormattedMessage id="info.version" /><Version/></p>
                    </div>
                </div>
            </div>
        </footer>
    )
  }

